// Values sourced from ~/objects/EmbedSettings.php
export const ALLOW_TITLE_OVERRIDE = 'allow_title_override';
export const CUSTOM_LOGO_LINK_URL = 'custom_logo_link_url';
export const CUSTOM_LOGO_URL = 'custom_logo_url';
export const CUSTOM_LOGO_USE_LINK = 'custom_logo_use_link';
export const HIDE_LIVE_LABEL = 'hide_live_label';
export const PLAYSINLINE = 'playsinline';
export const RESPONSIVE = 'responsive';
export const SHOW_360_LABEL = 'show_360_label';
export const SHOW_BYLINE = 'byline';
export const SHOW_BYLINE_BADGE = 'byline_badge';
export const SHOW_COLLECTIONS_BUTTON = 'collections_button';
export const SHOW_COMPASS = 'show_compass';
export const SHOW_CUSTOM_LOGO = 'custom_logo';
export const SHOW_EMBED_BUTTON = 'embed_button';
export const SHOW_EVENT_SCHEDULE = 'event_schedule';
export const SHOW_FULLSCREEN = 'fullscreen_button';
export const SHOW_HD_BUTTON = 'hd_button';
export const SHOW_LIKE_BUTTON = 'like_button';
export const SHOW_VIMEO_LOGO = 'vimeo_logo';
export const SHOW_VOLUME = 'volume';
export const SHOW_VOTE_BUTTON = 'vote_button';
export const SHOW_WATCH_LATER = 'watch_later_button';
export const STICKY_CUSTOM_LOGO = 'sticky_custom_logo';

// Values sourced from ~/objects/Live/RecurringLiveEvent/RecurringLiveEventEmbedSettings.php
export const SHOW_PLAYLIST = 'show_playlist';
export const SHOW_SCHEDULE = 'show_schedule';
export const USE_COLOR = 'use_color';
export const SHOW_LATEST_ARCHIVED_CLIP = 'show_latest_archived_clip';

// Values sourced from ~/src/Vimeo/Player2.php
export const AUTOPLAY = 'autoplay';
export const COLOR = 'color';
export const COLOR_ONE = 'colorOne';
export const COLOR_TWO = 'colorTwo';
export const COLOR_THREE = 'colorThree';
export const CONTROLS = 'controls';
export const CUSTOM_LOGO = 'custom_logo';
export const FULLSCREEN = 'fullscreen';
export const LOGO = 'logo';
export const LOOP = 'loop';
export const MUTED = 'muted';
export const SHOW_BADGE = 'badge';
export const LIKE = 'like';
export const SHOW_PLAYBAR = 'playbar';
export const SHOW_PORTRAIT = 'portrait';
export const SHOW_SHARE_BUTTON = 'share';
export const SHOW_TITLE = 'title';
export const SHOW_VOLUME_CONTROL = 'volume';

export const CUSTOM_LOGO_ID: string = 'custom_logo_id';

export const PLAYLIST: string = 'playlist';

export const SCHEDULE: string = 'schedule';

export const UPDATE_RLE_EMBED_SETTINGS: string = 'UPDATE_RLE_EMBED_SETTINGS';

export const UPDATE_EMBED_SETTINGS: string = 'UPDATE_EMBED_SETTINGS';

export const BROADCAST_CHANNEL_NAME: string = 'embed-communications';

export const BROADCAST_CHANNEL_MESSAGE_TYPE = {
  ASK_DATA: 'ask_data',
  NEW_DATA: 'new_data',
} as const;

export const BROADCAST_CHANNEL_MESSAGE_PAYLOAD_TYPE = {
  PASSWORD: 'password',
  HASHED_PASSWORD: 'hashed_password',
  REGISTRANT_UUID: 'registrant_uuid',
} as const;
